import React from 'react'
import { FaFacebookF, FaGithub } from 'react-icons/fa'
import { FiInstagram } from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'
import './footer.css'
import { BsLinkedin } from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      <a href="#home" className='footer__logo'>KOLA</a>
      <ul className='permalinks'>
        <li><a href="#home">Home</a> </li>
        <li><a href="#about">About</a> </li>
        <li><a href="#experience">Experience</a> </li>
        <li><a href="#services">Services</a> </li>
        <li><a href="#portfolio">Portfolio</a> </li>
        <li><a href="#contact">Contact</a> </li>

      </ul>
      <div className="footer__socials">
        <a href="https://github.com/Pappy-Vx/" target='_blank' rel='noreferrer'><FaGithub /></a>
        <a href="https://www.instagram.com/papikkolawole/" target='_blank' rel='noreferrer'><FiInstagram /></a>
        <a href="https://www.linkedin.com/in/kolawole-kolapo-21495b1b3/" target='_blank' rel='noreferrer'><BsLinkedin /></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Kolawole Kolapo 2022. All right reserved</small>
      </div>
    </footer>
  )
}

export default Footer